export function isValidCnpj(value: string): boolean {
    if (!value || !/^\d{14}$/.test(value)) {
        return false;
    }

    if (/^(\d)\1{13}$/.test(value)) {
        return false;
    }

    const digits = value.split('').map(Number);

    const calcDigit = (length: number, weights: number[]): number => {
        const sum = digits
            .slice(0, length)
            .reduce((acc, digit, index) => acc + digit * weights[index], 0);
        const remainder = sum % 11;
        return remainder < 2 ? 0 : 11 - remainder;
    };

    const firstWeights = [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
    const secondWeights = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];

    return (
        calcDigit(12, firstWeights) === digits[12] &&
        calcDigit(13, secondWeights) === digits[13]
    );
}

export default isValidCnpj;
